export default {
  title: 'Test-Zielgruppe',
  columns: {
    id: 'ID',
    phone_number: 'Telefonnummer',
  },
  filters: {
    search: {
      placeholder: 'Suchen',
    },
  },
  buttons: {
    send_test: 'Test senden',
  },
  feedback: {
    success: 'Erfolgreich gesendet',
    error: 'Senden fehlgeschlagen',
  },
};
